import PropTypes from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

export const Radio = memo(({ inputRadioGroupProps, description, title, ...props }) => (
  <div {...props}>
    <S.Title>{title}</S.Title>
    <S.Radio {...inputRadioGroupProps} />
  </div>
))

Radio.propTypes = {
  description: PropTypes.string,
  inputRadioGroupProps: PropTypes.object,
  title: PropTypes.string.isRequired,
}

Radio.displayName = 'Radio'
